import api, {handleAPIErrors} from 'shared/api'

const UPDATE_REQUEST = 'newJobs/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'newJobs/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'newJobs/UPDATE_FAILURE'
const UPLOAD_REQUEST = 'newJobs/UPLOAD_REQUEST'
const UPLOAD_SUCCESS = 'newJobs/UPLOAD_SUCCESS'
const UPLOAD_FAILURE = 'newJobs/UPLOAD_FAILURE'

const initialState = {
  result: {id: 0},
  updating: false,
  updated: false,
  uploading: false,
  uploaded: false,
  errors: {}
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(payload) {
  return {
    type: UPDATE_SUCCESS,
    payload,
  }
}

export function updateFailure(errors) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function uploadRequest() {
  return {
    type: UPLOAD_REQUEST,
  }
}

export function uploadSuccess(payload) {
  return {
    type: UPLOAD_SUCCESS,
    payload,
  }
}

export function uploadFailure(errors) {
  return {
    type: UPLOAD_FAILURE,
    errors,
  }
}

export function updateData(options, cb) {
  const config = {
    method: 'PATCH',
    body: JSON.stringify(options)
  }

  return (dispatch, getState) => {
    const state = getState()
    const { newJob } = state
    dispatch(updateRequest())

    return api(`api/v1/jobs/${newJob.result.id}`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(updateSuccess(json))

        cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(updateFailure(errors))
        })
      })
  }
}

export function uploadLogoImage(imageFile) {
  const form = new FormData()
  form.append("jobs[logo]", imageFile)

  const config = {
    method: 'PUT',
    body: form
  }

  return (dispatch, getState) => {
    const state = getState()
    const { newJob } = state
    dispatch(uploadRequest())

    return api(`api/v1/jobs/${newJob.result.id}`, {}, config, false, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(uploadSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(uploadFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        updated: true,
        errors: {},
        result: payload
      })
    case UPDATE_FAILURE:
      return {
        ...state,
        errors: errors,
        updating: false,
        updated: false
      }
    case UPLOAD_REQUEST:
      return Object.assign({}, state, {
        uploading: true
      })
    case UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        uploading: false,
        uploaded: true,
        errors: {},
        result: payload
      })
    case UPLOAD_FAILURE:
      return {
        ...state,
        errors: errors,
        uploading: false,
        uploaded: false
      }
    default:
      return state
  }
}
